export var ContactType;
(function (ContactType) {
    ContactType[ContactType["MAIN"] = 1] = "MAIN";
    ContactType[ContactType["BILLING"] = 2] = "BILLING";
    ContactType[ContactType["SHIPPING"] = 3] = "SHIPPING";
    ContactType[ContactType["PURCHASING"] = 4] = "PURCHASING";
})(ContactType || (ContactType = {}));
//# sourceMappingURL=contact-type.js.map